
class Store {
  constructor() {
    this.store = {};
  }

  set(key, dataSource) {
    this.store[key] = dataSource;
  }

  get(key) {
    return this.store[key];
  }
}

const DataSourceStore = new Store();

export { DataSourceStore };
